import { useContext } from "react";
import { SMContext } from "../context/smContext";
import { Typography, Button } from "@mui/material";
import ModalSM from "./ModalSM";
import DivExist from "./DivExist";
import DivInline from "./DivInline";
import Divider10 from "./Divider10";
import WarningSign from "asset/svgComp/WarningSign";
export default function WindowConfirm() {
  const [state, dispatch] = useContext(SMContext);
  const { windowConfirm, windowConfirmTitle, onConfirm, onCancel, callback, showWindowConfirmAlertSign } = state;
  const handleClose = () => {
    dispatch({
      type: "WINDOW_CONFIRM",
      payload: { status: false, windowConfirmTitle: "" },
    });
  };

  return (
    <ModalSM open={windowConfirm} onClose={handleClose} disableBottomClose>
      <DivExist show={showWindowConfirmAlertSign}>
        <DivInline justifyContent="center" alignItems="center">
          <WarningSign width={5} sizeUnit="vw" />
        </DivInline>
      </DivExist>
      <Typography sx={{ marginTop: 3 }} align="center">
        {windowConfirmTitle}
      </Typography>
      <Divider10 />
      <DivInline justifyContent="space-around">
        <Button
          variant="contained"
          size="small"
          onClick={() => {
            onConfirm();
            handleClose();
            if (callback) callback();
          }}
        >
          Yes
        </Button>
        <Button
          variant="contained"
          size="small"
          onClick={() => {
            if (onCancel) onCancel();
            handleClose();
            if (callback) callback();
          }}
        >
          No
        </Button>
      </DivInline>
    </ModalSM>
  );
}
